import { render, staticRenderFns } from "./DefaultShop.vue?vue&type=template&id=24f02d20"
import script from "./DefaultShop.vue?vue&type=script&lang=js"
export * from "./DefaultShop.vue?vue&type=script&lang=js"
import style0 from "./DefaultShop.vue?vue&type=style&index=0&id=24f02d20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports